import { useCallback } from "react";

import { useMarkRenewalAsUnpaidMutation } from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";

export function useMarkRenewalAsUnpaid(
  renewalLocator: string,
  onClose: () => void
) {
  const [markRenewalAsUnpaid, { loading }] = useMarkRenewalAsUnpaidMutation();

  const handleSubmit = useCallback(async () => {
    if (!renewalLocator) return;
    try {
      await markRenewalAsUnpaid({
        variables: { renewalLocator },
      });
      Toast.showSuccess("Operation was performed successfully!");
    } catch (e) {
      Toast.showError(e.message);
    }
    onClose();
  }, [renewalLocator, onClose]);

  return {
    handleSubmit,
    loading,
  };
}
